import { render } from "./GenerateTestData.vue?vue&type=template&id=29e04994"
import script from "./GenerateTestData.vue?vue&type=script&lang=js"
export * from "./GenerateTestData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__